import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import mr from './locales/mr.json';
import hi from './locales/hi.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      mr: { translation: mr },
      hi: { translation: hi },
      en: { translation: en },
    },
    fallbackLng: 'en',
    lng: 'en', // English first (Marathi/Hindi available as switch)
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'formmitra-lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
